"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterOutCurrentCategory = void 0;
const filterOutCurrentCategory = ({
  categories,
  pageId
}) => (categories ?? []).filter(category => category !== null && category.landingPageId !== pageId);
exports.filterOutCurrentCategory = filterOutCurrentCategory;
